var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar"},[_c('h2',[_c('i',{staticClass:"iconfont icon-gongchang"}),_vm._v("\n         "+_vm._s(_vm.$t('menu0'))+"\n        "),_c('Divider',{staticStyle:{"background-color":"#aaa"},attrs:{"type":"vertical"}}),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.$t('equipmentSubTitle')))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2eeb82c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--0-1!./src/views/home/components/navbar.vue
// module id = null
// module chunks = 